import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from '../app.service';
import { mygarage } from '../shared/Models/Constants';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    standalone: false
})
export class FaqsComponent implements OnInit, AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);

  isAcura: boolean = false;
  myGarageHost = "https://mygarage.honda.com"
  isGDO:boolean = false

  constructor(private service: AppService, private router: Router) { }
  ngAfterViewInit(): void {
    this.service.checkIsDataAvailable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      setTimeout(() => {
        
        if (res) {
          this.setIsAcuraLocally()
        } else {
          this.getVehicleDetails()
        }
      }, 1);
    });
  }

  ngOnInit(): void {
    this.myGarageHost = mygarage
    this.isGDO = this.service.getIsGdoPoral()
  }
  onLinkClick() {
    this.router.navigate(['/'])
  }
  setIsAcuraLocally() {
    let vehicleData = this.service.getVehicleData()
    if (vehicleData) {
      if (vehicleData.make == "Acura") {
        this.isAcura = true
      }
    }
  }
  getVehicleDetails() {
    this.service.MyVehicle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res && res.status == "SUCCESS") {
        let vehicleInfo = res.vehicleInfo
        if (vehicleInfo && vehicleInfo.length > 0) {
          let vehicleMake = vehicleInfo[0].DivisionName
          if (vehicleMake == 'Honda') {
            this.isAcura = false
          } else {
            this.isAcura = true
          }
        }
      }
    })
  }


}
